"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _utils = require("../../utils");

var _communicationMethodTypes = _interopRequireDefault(require("ui-addon-upgrades/_core/communicationMethods/communicationMethodTypes"));

var _upgradeDataPropsInterface = require("ui-addon-upgrades/_core/common/data/upgradeData/interfaces/upgradeDataPropsInterface");

var _communicationMethodsConfig = _interopRequireDefault(require("ui-addon-upgrades/_core/communicationMethods/communicationMethodsConfig"));

var tracker = _interopRequireWildcard(require("ui-addon-upgrades/_core/common/eventTracking/tracker"));

var _CommunicationButton = _interopRequireDefault(require("ui-addon-upgrades/_core/communicationMethods/CommunicationButton"));

var _UIButton = _interopRequireDefault(require("UIComponents/button/UIButton"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _UpgradeProductProperties = _interopRequireDefault(require("self-service-api/constants/UpgradeProductProperties"));

var _url = require("ui-addon-upgrades/_core/common/navigation/url");

var _PurchaseMotionTypes = require("ui-addon-upgrades/_core/purchaseMotions/PurchaseMotionTypes");

var _partial = _interopRequireDefault(require("react-utils/partial"));

var INITIAL = _communicationMethodTypes.default.INITIAL;

var connectCommunicationMethods = function connectCommunicationMethods(Component) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    onDark: false,
    buttonType: 'selectableButton'
  };

  var CommunicationMethods = /*#__PURE__*/function (_React$Component) {
    (0, _inherits2.default)(CommunicationMethods, _React$Component);

    function CommunicationMethods(props) {
      var _this;

      (0, _classCallCheck2.default)(this, CommunicationMethods);
      _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(CommunicationMethods).call(this, props));
      _this.state = {
        selectedCommunicationMethod: props._overrideCommunicationMethodKey || INITIAL
      };
      var _this$props = _this.props,
          upgradeData = _this$props.upgradeData,
          _overrideCommunicationMethodKey = _this$props._overrideCommunicationMethodKey,
          onConfirm = _this$props.onConfirm,
          onCancel = _this$props.onCancel;

      if (_overrideCommunicationMethodKey === _communicationMethodTypes.default.MEETING) {
        var communicationMethod = _communicationMethodsConfig.default.filter(function (_ref) {
          var communicationKey = _ref.communicationKey;
          return _communicationMethodTypes.default.MEETING === communicationKey;
        })[0];

        communicationMethod.onClick({
          upgradeData: upgradeData,
          onCancel: onCancel
        }, onConfirm);
      }

      _this.handleUpgradeClick = _this.handleUpgradeClick.bind((0, _assertThisInitialized2.default)(_this));
      _this.setSelectedCommunicationMethod = _this.setSelectedCommunicationMethod.bind((0, _assertThisInitialized2.default)(_this));
      return _this;
    }

    (0, _createClass2.default)(CommunicationMethods, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        var upgradeData = this.props.upgradeData;
        tracker.track('communicationMethodsInteraction', Object.assign({
          action: 'viewed'
        }, upgradeData));
      }
    }, {
      key: "handleUpgradeClick",
      value: function handleUpgradeClick() {
        var upgradeData = this.props.upgradeData;
        var upgradeLink = _UpgradeProductProperties.default[upgradeData.upgradeProduct].upgradeLink;
        tracker.track('contactSalesModalInteraction', Object.assign({
          action: 'clicked upgrade'
        }, upgradeData));
        (0, _url.openNewTab)(upgradeLink(upgradeData.source, upgradeData.upgradeProduct));
      }
    }, {
      key: "setSelectedCommunicationMethod",
      value: function setSelectedCommunicationMethod(selectedCommunicationMethod) {
        this.setState({
          selectedCommunicationMethod: selectedCommunicationMethod
        });
      }
    }, {
      key: "renderButtonComponents",
      value: function renderButtonComponents() {
        var _this2 = this;

        var _this$props2 = this.props,
            upgradeData = _this$props2.upgradeData,
            onConfirm = _this$props2.onConfirm,
            onCancel = _this$props2.onCancel;
        return _communicationMethodsConfig.default.map(function (communicationMethod, key) {
          var communicationKey = communicationMethod.communicationKey,
              onClick = communicationMethod.onClick,
              image = communicationMethod.image;
          return _react.default.createElement(_CommunicationButton.default, {
            key: key,
            image: image,
            communicationKey: communicationKey,
            onClick: (0, _partial.default)(onClick, {
              upgradeData: upgradeData,
              onCancel: onCancel
            }, onConfirm),
            setSelectedCommunicationMethod: _this2.setSelectedCommunicationMethod,
            upgradeData: upgradeData,
            buttonType: options.buttonType
          });
        });
      }
    }, {
      key: "renderSelectedMethodComponent",
      value: function renderSelectedMethodComponent() {
        var selectedCommunicationMethod = this.state.selectedCommunicationMethod;
        var _this$props3 = this.props,
            onConfirm = _this$props3.onConfirm,
            upgradeData = _this$props3.upgradeData;

        var communicationMethod = _communicationMethodsConfig.default.filter(function (_ref2) {
          var communicationKey = _ref2.communicationKey;
          return selectedCommunicationMethod === communicationKey;
        })[0];

        if (!communicationMethod || !communicationMethod.SelectedMethodComponent) {
          return null;
        }

        var SelectedMethodComponent = communicationMethod.SelectedMethodComponent;
        return _react.default.createElement(SelectedMethodComponent, {
          onDark: options.onDark,
          onConfirm: onConfirm,
          upgradeData: upgradeData,
          setSelectedCommunicationMethod: this.setSelectedCommunicationMethod
        });
      }
    }, {
      key: "renderUpgradeComponent",
      value: function renderUpgradeComponent() {
        var purchaseMotionEligibility = this.props.upgradeData.purchaseMotionEligibility;

        if (!purchaseMotionEligibility) {
          return null;
        }

        var selectedCommunicationMethod = this.state.selectedCommunicationMethod;
        var isEligibleToTouchlesslyPurchase = purchaseMotionEligibility.indexOf(_PurchaseMotionTypes.BUY_TOUCHLESS) !== -1;

        if (!isEligibleToTouchlesslyPurchase || selectedCommunicationMethod !== INITIAL) {
          return null;
        }

        var linkUse = options.onDark ? 'link-on-dark' : 'link';
        return _react.default.createElement(_UIButton.default, {
          className: "m-top-2 text-center upgrade",
          use: linkUse,
          onClick: this.handleUpgradeClick,
          block: true
        }, _react.default.createElement(_FormattedMessage.default, {
          message: "upgrades.pqlModal.upgradeNow"
        }));
      }
    }, {
      key: "render",
      value: function render() {
        var _overrideCommunicationMethodKey = this.props._overrideCommunicationMethodKey;
        var newProps = {
          buttonComponents: this.renderButtonComponents(),
          selectedMethodComponent: this.renderSelectedMethodComponent(),
          upgradeComponent: this.renderUpgradeComponent()
        };

        if (_overrideCommunicationMethodKey === _communicationMethodTypes.default.MEETING) {
          return null;
        }

        return _react.default.createElement(Component, Object.assign({}, newProps, (0, _utils.omit)(this.props, '_overrideCommunicationMethodKey')));
      }
    }]);
    return CommunicationMethods;
  }(_react.default.Component);

  var propsToEnforce = (0, _utils.omit)(Component.propTypes, ['buttonComponents', 'selectedMethodComponent', 'upgradeComponent']);
  CommunicationMethods.propTypes = Object.assign({}, propsToEnforce, {}, _upgradeDataPropsInterface.upgradeDataPropsInterface, {
    onConfirm: _propTypes.default.func.isRequired,
    _overrideCommunicationMethodKey: _propTypes.default.string
  });
  return CommunicationMethods;
};

var _default = connectCommunicationMethods;
exports.default = _default;
module.exports = exports.default;